import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Switch, notification } from 'antd';
import PageTitle from '../../../Utils/PageTitle';
import CustomTypography from '../../CustomComponents/CustomTypography';
import BreadCrumbComponent from '../../CustomComponents/BreadCrumbComponent';
import Spinner from '../../CustomComponents/Spinner';
import { ContainerRow, TitleRow } from '../styledComponents';
import { SettingRow, SettingHeader } from './styledComponents';
import { getClinicSettings, updateClinicSettings } from '../../../Apis/ClinicAdmin';

const ClinicSettings = () => {
  const [theme] = useSelector(state => [state.themeReducer]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  // When ON, Patient Type (STC/LTC) is mandatory for the provider/doctor to
  // select while dictating a patient. When OFF, it is optional.
  const [patientTypeMandatory, setPatientTypeMandatory] = useState(false);

  const fetchSettings = () => {
    setLoading(true);
    getClinicSettings()
      .then(response => {
        setLoading(false);
        if (response?.data?.success) {
          const config = response.data.result?.[0];
          setPatientTypeMandatory(!!config?.patientTermTypeRequired);
        }
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchSettings();
    // eslint-disable-next-line
  }, []);

  const handlePatientTypeToggle = checked => {
    const previous = patientTypeMandatory;
    setPatientTypeMandatory(checked);
    setSaving(true);
    updateClinicSettings({ patientTermTypeRequired: checked })
      .then(response => {
        setSaving(false);
        if (response?.data?.success) {
          const config = response.data.result?.[0];
          setPatientTypeMandatory(!!config?.patientTermTypeRequired);
          notification['success']({
            message: 'Saved',
            description:
              response.data.message ||
              `Patient Type (STC/LTC) is now ${
                checked ? 'mandatory' : 'optional'
              } during dictation.`
          });
        } else {
          setPatientTypeMandatory(previous);
          notification['error']({
            message: 'Failed',
            description: response?.data?.message || 'Could not update setting.'
          });
        }
      })
      .catch(err => {
        console.log(err);
        setSaving(false);
        setPatientTypeMandatory(previous);
      });
  };

  const BreadCrumbItems = [
    {
      name: 'Settings',
      path: '/dashboard/settings'
    },
    {
      name: 'Clinic Settings'
    }
  ];

  return (
    <>
      <PageTitle title='Clinic Settings' />
      <ContainerRow gutter={[0, 40]}>
        <TitleRow justify='space-between'>
          <CustomTypography color={theme['@text-color']}>
            Clinic Settings
          </CustomTypography>
        </TitleRow>
        <BreadCrumbComponent items={BreadCrumbItems} />
        {loading ? (
          <Spinner />
        ) : (
          <SettingRow>
            <SettingHeader>
              <span className='setting-title'>Patient Type (STC/LTC)</span>
              <Switch
                checked={patientTypeMandatory}
                loading={saving}
                onChange={handlePatientTypeToggle}
              />
            </SettingHeader>
            <span className='setting-description'>
              When enabled, providers must select the patient type (STC/LTC)
              while dictating a patient.
            </span>
          </SettingRow>
        )}
      </ContainerRow>
    </>
  );
};

export default ClinicSettings;
